<template>
  <div class="download">
    <div class="download_container">
      <h4 class="title">下载来布码、数据保险箱客户端</h4>
      <p class="tip">您的数据资产化管控专家</p>
      <div class="download_wrap">
        <div class="download-item">
          <div class="item-top">
            <img style="height: 100%;" src="../assets/img/code_img.png" alt=""/>
          </div>
          <h4>扫描二维码下载移动客户端</h4>
          <p>支持Android、iOS移动设备</p>
        </div>
        <div class="download-item" @mouseenter="isWinVisible = true" @mouseleave="isWinVisible = false">
          <div class="item-top">
            <img src="../assets/img/download_icon.png" alt="" v-if="isWinVisible"/>
            <p v-if="isWinVisible">点击下载来布码 Windows 客户端（公测版）</p>
            <!-- <a v-if="isWinVisible" href="https://wechat.huoxunapp.com/数保保.exe"></a> -->
            <a v-if="isWinVisible" href="https://www.iclabs.cn/来布码.exe"></a>
            <img src="../assets/img/window_icon.png" alt="" v-else />
          </div>
          <h4>来布码 Windows 客户端（公测版）</h4>
          <p>为了更好的兼容性以及安全性，当前仅支持Windows10及以上系统</p>
        </div>
        <div class="download-item" @mouseenter="isWinVisible2 = true" @mouseleave="isWinVisible2 = false">
          <div class="item-top">
            <img src="../assets/img/download_icon.png" alt="" v-if="isWinVisible2"/>
            <p v-if="isWinVisible2">点击下载数据保险箱 Windows 客户端</p>
            <!-- <a v-if="isWinVisible2" href="https://wechat.huoxunapp.com/数保保.exe"></a> -->
            <a v-if="isWinVisible2" href="https://www.iclabs.cn/datasafe_V1.5.exe"></a>
            <img src="../assets/img/window_icon.png" alt="" v-else />
          </div>
          <h4>数据保险箱 Windows 客户端</h4>
          <p>为了更好的兼容性以及安全性，当前仅支持Windows10及以上系统</p>
        </div>
        <!-- <div class="download-item" @mouseenter="isLinuxVisible = true" @mouseleave="isLinuxVisible = false">
          <div class="item-top">
            <img src="../assets/img/download_icon.png" alt="" v-if="isLinuxVisible"/>
            <p v-if="isLinuxVisible">点击下载数保保 Linux 客户端</p>
            <a v-if="isLinuxVisible" href="https://wechat.huoxunapp.com/数保保客户端.exe"></a>
            <img src="../assets/img/linux_icon.png" alt="" v-else />
          </div>
          <div class="item-bottom">
            <h4>数保保Linux客户端</h4>
            <p class="inline">仅支持</p>
            <a
              target="_blank"
              href="https://www.ieisystem.com/keyarchos/"
              style="text-decoration: none;"
              >浪潮KeyarchOS5.8系统</a>
              <div class="hover-wrap">
                <p class="hover"><i class="el-icon-view"></i>
                浪潮信息澎湃技术认证</p>
                <div class="certificate">
                  <img src="../assets/img/zhengshu8.png" alt="" />
                </div>
              </div>
          </div>
        </div> -->
      </div>
    </div>
    <!-- 表格模块 -->
    <div class="excel_wrap">
      <div class="title">*为了更好的兼容性以及安全性，当前通过安全分享的加密文件仅支持以下方式查看加密文件</div>
      <div class="content">
        <div class="column">
          <div class="column-item title">文件类型</div>
          <div class="column-item size_1">word</div>
          <div class="column-item size_1">excel</div>
          <div class="column-item size_1">powerpoint</div>
          <div class="column-item size_1">pdf</div>
          <div class="column-item size_1">图片</div>
          <div class="column-item size_1">视频</div>
          <div class="column-item size_1">音频</div>
        </div>
        <div class="column">
          <div class="column-item title">文件后缀</div>
          <div class="column-item size_1">.docx</div>
          <div class="column-item size_1">.xlsx</div>
          <div class="column-item size_1">.pptx</div>
          <div class="column-item size_1">.pdf</div>
          <div class="column-item size_1">.png/.jpg/.gif/.bmp</div>
          <div class="column-item size_1">.mp4/.mov</div>
          <div class="column-item size_1">.mp3</div>
        </div>
        <div class="column">
          <div class="column-item title">Windows支持的软件</div>
          <div class="column-item size_3">office</div>
          <div class="column-item size_1">Adobe Acrobat Reader</div>
          <div class="column-item size_1">照片（操作系统自带）</div>
          <div class="column-item size_2">VLC</div>
        </div>
        <!-- <div class="column">
          <div class="column-item title">Linux支持的软件</div>
          <div class="column-item size_4">WPS</div>
          <div class="column-item size_1">gimp</div>
          <div class="column-item size_2">VLC</div>
        </div> -->
        <div class="column">
          <div class="column-item title">APP</div>
          <!-- <div class="column-item size_7">来布码</div> -->
          <div class="column-item size_7">数据保险箱</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isWinVisible: false,
      isWinVisible2: false,
      isLinuxVisible: false,
      isShowCertificate: false
    };
  },
  beforeMount() {
    this.detectDeviceType();
  },
  methods: {
    detectDeviceType() {
      let userAgent = navigator.userAgent;
      let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
      if (isMobile) {
        // 进一步判断是安卓还是苹果
        // if (/Android/i.test(userAgent)) {
        //   this.deviceType = 'Android';
        // } else if (/iPhone|iPad|iPod/.test(userAgent)) {
        //   this.deviceType = 'iOS';
        // }
        // this.$router.replace("/downloadSbb");
        this.$router.replace("/downloadApp");
      } else {
        // this.deviceType = 'Desktop';
      }

      // console.log('Device Type:', this.deviceType);
    },
  }
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.download {
  width: 100%;
}
.download_container {
  width: 100%;
  min-height: 710px;
  position: relative;
  padding-top: 80px;
  box-sizing: border-box;
  background-image: url("../assets/img/download_bg.png");
  .title {
    font-weight: 500;
    font-size: 48px;
    color: #262626;
    line-height: 48px;
    text-align: center;
    position: relative;
  }
  .tip {
    height: 24px;
    font-weight: 500;
    font-size: 24px;
    color: #262626;
    line-height: 24px;
    margin-top: 24px;
    margin-bottom: 30px;
    position: relative;
    text-align: center;
  }
}
.download_wrap {
  margin-top: 26px;
  width: 1200px;
  position: absolute;
  left: 50%;
  margin-left: -600px;
  display: flex;
  /* justify-content: space-between; */ /* 放开linux下载入口后，这里放开 */
  justify-content: center; /* 放开linux下载入口后，这里删掉 */
}

.download-item {
  width: 376px;
  height: 398px;
  background: #ffffff;
  border-radius: 16px;
  padding: 68px 77px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin: auto 40px; /* 放开linux下载入口后，这里删掉 */
  .item-top {
    height: 174px;
    display: flex !important;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    transition: all 0.3s;
    > p {
      margin-top: 23px;
      font-size: 14px;
      color: #262626;
    }
    a {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
    }
  }
  .item-top:hover {
    cursor: pointer;
  }
  h4 {
    font-size: 14px;
    color: #262626;
    line-height: 14px;
    margin-top: 40px;
    margin-bottom: 12px;
  }
  p {
    font-size: 12px;
    color: #666666;
    line-height: 18px;
  }
  .item-bottom a {
    display: inline;
    font-size: 12px;
    color: #2f51ff;
    line-height: 18px;
  }
  .inline {
    display: inline;
  }
  .hover-wrap {
    z-index: 999;
    position: relative;
  }
  .hover-wrap:hover {
    .certificate {
      display: block;
    }
  }
  .item-bottom a:active {
    color: #2f51ff;
  }
  .item-bottom i {
    margin-right: 3px;
  }
}
.certificate {
  display: none;
  width: 208px;
  height: 275px;
  position: absolute;
  top: -245px;
  right: 184px;
  transition: all 0.3s;
  img {
    width: 208px;
    height: 275px;
  }
}

.excel_wrap {
  width: 1200px;
  position: relative;
  left: 50%;
  margin-left: -600px;
  min-height: 638px;
  padding: 56px 0;
  .title {
    text-align: center;
    height: 24px;
    font-size: 16px;
    color: #262626;
    line-height: 24px;
  }
  .content {
    display: flex;
    width: 100%;
    margin-top: 40px;
    border-bottom: 1px solid #eceff4;
    border-right: 1px solid #eceff4;
  }
  .column {
    width: 100%;
  }
  .column-item {
    width: 100%;
    background: #ffffff;
    border-top: 1px solid #eceff4;
    border-left: 1px solid #eceff4;
    text-align: center;
  }
  .column-item.title {
    height: 46px;
    background: #fbfbfb;
    font-weight: 600;
    font-size: 14px;
    color: #262626;
    line-height: 46px;
    text-align: center;
  }
  .size_1 {
    height: 56px;
    line-height: 56px;
  }
  .size_2 {
    height: 112px;
    line-height: 112px;
  }
  .size_3 {
    height: 168px;
    line-height: 168px;
  }
  .size_4 {
    height: 224px;
    line-height: 224px;
  }
  .size_7 {
    height: 392px;
    line-height: 392px;
  }
}
</style>
